
import alignElements from './align-elements';

export default function align(elements, rect, alignment) {
    alignElements(elements, rect, alignment, "x", "width");
}